<template>
  <v-flex>
    <!-- <AppModel /> has no interface, just needs to be loaded -->

    <v-row dense>
      <v-col cols="2">
        <AppPanel @submit="handlePanelSubmit" />
      </v-col>
      <v-col cols="10">
        <v-row class="mb-5 px-1">
          <v-col>
            <AppTable :raw-data="rawData" :year="year" />
          </v-col>
        </v-row>
        <v-row class="mb-5 px-1">
          <v-col cols="6">
            <AppGraph :data-array="dataArray" :is-loading="isLoading" />
          </v-col>
          <v-col cols="6">
            <AppGraph2 :raw-data="rawData" :is-loading="isLoading" />
          </v-col>
        </v-row>
      </v-col>
      <!-- split into columns, stepper on the left, graph on the right-->
    </v-row>
    <LegendFooter />
  </v-flex>
</template>


<script>
import AppTitle from '@/components/shared/Title'
import AppPanel from '@/components/subs/KBEUI_panel'
import AppGraph from '@/components/subs/KBEUI_graph1'
import AppTable from '@/components/subs/KBEUI_dataTable'
import AppGraph2 from '@/components/subs/KBEUI_graph2'
import LegendFooter from '@/components/subs/KBEUI_legendFooter'
import _ from 'lodash'
import axios from 'axios';
import utils from '@/utils';

const testing = false; // turn false for production build

export default {
  data: () => ({
    year: "2020",
    dataArray: null,
    rawData: null,
    isLoading: false,
  }),
  components: {
    AppTitle,
    AppPanel,
    AppGraph,
    AppTable,
    AppGraph2,
    LegendFooter,
  },
  methods: {
    handlePanelSubmit(year) {
      try {
        let url = `${year}.json`;
        // this.isLoading = true;
        axios.get(url).then((response) => {
          var rawData = response.data;
          for (let key of Object.keys(rawData)) {
            rawData[key] = Object.values(rawData[key])
          }
          this.dataArray = utils.processData(rawData);
          this.rawData = rawData;
          // this.year = year;
          // this.isLoading = false;
        }).catch((e) => { utils.axiosErrorHandler(e); this.isLoading = false });
      } catch (error) {
        utils.errorRun("Frontend Error:\n" + error);
        // this.isLoading = false;
      }
    },
  },
}
</script>


<style lang='stylus' scoped>

#explorerTitle
  font-family: 'Poppins' !important
  font-weight: bold
  text-align: center
  font-size: 4rem
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5)
  color: #DFDFDF
  line-height: 1.2
  text-transform: uppercase

  .ex-title
    font-size: 7rem !important

  .affiliation
    margin-top: 0.5rem
    text-transform: none
    font-size: 1.2rem


.index-video-wrapper
  position: relative
  width: 100vw



</style>
<!-- comment -->